"use client";

import { useEffect } from "react";
import { reportClientError } from "@/lib/mobile/report-error";

// Последний рубеж: ошибка в корневом layout. Обязан рисовать <html> и <body>
// сам — обычный layout здесь уже не работает.
export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    reportClientError("render", error.message || String(error), error.stack, { digest: error.digest, boundary: "global" });
  }, [error]);
  return (
    <html lang="ru">
      <body style={{ margin: 0, fontFamily: "system-ui, -apple-system, sans-serif" }}>
        <main style={{ minHeight: "100dvh", display: "grid", placeItems: "center", padding: 24 }}>
          <div style={{ maxWidth: 420, textAlign: "center" }}>
            <div style={{ fontSize: 22, fontWeight: 700 }}>Приложение не открылось</div>
            <p style={{ opacity: 0.7, marginTop: 8, lineHeight: 1.45 }}>Отчёт об ошибке отправлен. Перезагрузите страницу.</p>
            <div style={{ display: "flex", gap: 10, justifyContent: "center", marginTop: 18 }}>
              <button type="button" onClick={reset} style={{ padding: "10px 18px", borderRadius: 999, border: "none", background: "#111", color: "#fff", fontSize: 15 }}>
                Попробовать снова
              </button>
              <button type="button" onClick={() => window.location.reload()} style={{ padding: "10px 18px", borderRadius: 999, border: "1px solid rgba(0,0,0,0.2)", background: "transparent", fontSize: 15 }}>
                Перезагрузить
              </button>
            </div>
          </div>
        </main>
      </body>
    </html>
  );
}
